import React from 'react';
import './JobDesc.scss';

interface Props {
  name: string;
  department: string;
  city: string;
  responsibilities: string;
  requirements: string;
  link: string;
}

const JobDesc: React.FC<Props> = props => {
  const {
    name,
    department,
    city,
    responsibilities,
    requirements,
    link,
  } = props;

  return (
    <div className="job-desc">
      <div className="job-info">
        <h3 className="name">{name}</h3>
        <p>
          {department} · {city}
        </p>
      </div>
      <div className="job-desc-wrapper">
        <div className="job-desc-item">
          <div className="title">
            <span>主要职责</span>
            <b className="line" />
          </div>
          <pre className="content">{responsibilities}</pre>
        </div>
        <div className="job-desc-item">
          <div className="title">
            <span>职位要求</span>
            <b className="line" />
          </div>
          <pre className="content">{requirements}</pre>
        </div>
      </div>
      <div className="btn-wrapper">
        <a
          className="to-zhipin"
          rel="noopener noreferrer"
          target="_blank"
          role="button"
          href={link}
        >
          我要应聘
        </a>
      </div>
    </div>
  );
};

export default JobDesc;
